import React from 'react';
import classNames from 'classnames';

const Page = ({className, ...rest}) => (
    <div className={classNames('dp__page', className)} {...rest} />
);

export default Page;
